import React from 'react';
import { TOOLBARS } from 'wix-rich-content-editor-common';
import { InsertGalleryIcon } from '../icons';
import { getDefaultComponentData } from '../types';
import ToolbarIconTooltip from '../../../components/ToolbarIconTooltip';
export default (function (_a) {
    var helpers = _a.helpers, t = _a.t;
    return [
        {
            type: 'file',
            multi: true,
            name: 'Gallery',
            getIcon: function () { return function () { return (React.createElement(ToolbarIconTooltip, { tooltipTextKey: 'editorToolbar.tooltips.addGallery' },
                React.createElement(InsertGalleryIcon, null))); }; },
            componentData: getDefaultComponentData(),
            helpers: helpers,
            toolbars: [TOOLBARS.FOOTER, TOOLBARS.SIDE, TOOLBARS.INSERT_PLUGIN],
        },
    ];
});
//# sourceMappingURL=insert-buttons.js.map